import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SplashLoader from "@components/ui/Loaders/SplashLoader";
import { useUserData } from "../context/OAuth/AuthContext";

const CreatePlansGuard = ({ children, currentPath = "" }) => {
  const { showCreatePlan } = useUserData();
  const navigate = useNavigate();
  const location = useLocation();

  // Paths where create-my-plans should NOT redirect
  const allowedPaths = [
    "/create-my-plans",
    "/contact-us",
    "/first-forms",
    "/logout",
    "/login",
    "/my-account"
  ];

  // Check if current route is one of the allowed paths
  const pathAllowed = (path) =>
    allowedPaths.some(
      (allowed) => path === allowed || path.startsWith(`${allowed}/`),
    );
  const isCurrentPathAllowed = pathAllowed(currentPath);
  const isLocationPathAllowed = pathAllowed(location.pathname);

  useEffect(() => {
    // Only redirect if showCreatePlan is true AND we're NOT on an allowed path
    if (showCreatePlan && !isLocationPathAllowed) {
      navigate("/create-my-plans", { replace: true });
    } else if (!showCreatePlan && location.pathname === "/create-my-plans") {
      navigate("/", { replace: true });
    }
  }, [showCreatePlan, isLocationPathAllowed, navigate]);

  // Show loader while redirecting
  if (showCreatePlan && !isLocationPathAllowed) {
    return <SplashLoader />;
  }

  return children;
};

export default CreatePlansGuard;
